import Color from 'color'

// Helper function to convert hex colors to hue values (0-360)
const hexToHue = (hex: string): number => {
  return Color(hex).hsl().hue()
}

/**
 * Function to pick a new color which is as visually distinct as possible
 * from an array of existing colors.
 * @returns a hopefully distinct color
 */
export const pickDistinctColor = (
  existingColors: ReadonlyArray<string>
): string => {
  if (existingColors.length === 0) {
    // Default first color (Ant Design primary blue)
    return '#1890ff'
  }

  // Convert existing colors to hues and sort them
  const hues = existingColors.map(hexToHue).sort((a, b) => a - b)

  // Add first hue + 360 at the end to handle circular wrap-around
  const extendedHues = [...hues, hues[0] + 360]

  // Find the largest gap between consecutive hues
  let maxGap = 0
  let newHue = 0

  for (let i = 0; i < hues.length; i++) {
    const gap = extendedHues[i + 1] - extendedHues[i]
    if (gap > maxGap) {
      maxGap = gap
      newHue = (extendedHues[i] + gap / 2) % 360
    }
  }

  // Set saturation and lightness to ensure bright, vivid colors
  const saturation = 80 // vivid colors
  const lightness = 60 // bright enough for dark backgrounds

  return Color.hsl(newHue, saturation, lightness).hex()
}
